function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnBluetooth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 151",
    d: "m20.57 14.27 2.94 2-2.94 2zM20 7A13 13 0 1 1 7 20 13 13 0 0 1 20 7m1.79 13 4.14-2.87a1.006 1.006 0 0 0 0-1.65l-5.71-4a1 1 0 0 0-1-.07 1.39 1.39 0 0 0-.62 1.07v5.22l-3.28-2.79A1.022 1.022 0 1 0 14 16.47L18.36 20l-4.24 3.42a1 1 0 1 0 1.26 1.56l3.18-2.68v5.46c0 .37.29.6.62.78a1.12 1.12 0 0 0 .47.11 1 1 0 0 0 .57-.18l5.71-3.95a1.006 1.006 0 0 0 0-1.65zm-1.22 5.75 3-2.05-3-2z",
    style: {
      fill: "#5e5e5d"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBluetooth);
export default __webpack_public_path__ + "static/media/icn-bluetooth.1427f282b7d42ed9f974226f17bce94e.svg";
export { ForwardRef as ReactComponent };